import { ClientView } from "@/features/client-view";
import { verifyRoles } from "@/utils/verifyRoles";
import { createFileRoute } from "@tanstack/react-router";
import { isomorphicHttpClient } from "../../../httpClient";

export const Route = createFileRoute("/dashboard/clients/$tenantId/$clientId")({
  component: ClientView,
  beforeLoad: async ({ context: { queryClient }, params }) => {
    await verifyRoles(["INIC_ADMIN", "ORG_ADMIN", "ORG_OPERATOR"]);

    queryClient.prefetchQuery({
      queryKey: ["clients", params.clientId],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET(
          "/v1/clients/{tenantId}/{clientId}",
          {
            params: {
              path: { tenantId: params.tenantId, clientId: params.clientId },
            },
          },
        );

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
